import React, { useEffect, useState } from 'react'
import CustomAddPage from '../../components/CustomComponents/CustomAddPage'
import { useCategory } from '../../hooks/Features/useCategory'
import { isArray, uploadFilesToAws } from '../../shared/constants'

function Category({ category }) {
  const [categoryForm, setCategoryForm] = useState({
    categoryName: '',
    description: '',
    discount: 0,
    file: '',
    categoryCode: '',
    active: true,
  })
  // debugger
  const { addCategory, updateCategory } = useCategory()
  const handleCategory = async () => {
    let location = categoryForm.file
    if (!isArray(categoryForm.file)) {
      location = await uploadFilesToAws(categoryForm.file)
    }
    if (category!== undefined) {
      await updateCategory({ ...categoryForm, image: location[0], categoryId: category[0]._id })
    } else {
      await addCategory({ ...categoryForm, image: location!== undefined && location[0] })
    }
  }

  useEffect(() => {
    if (category!== undefined) {
      setCategoryForm({
        ...categoryForm,
        categoryName: category[0].categoryName,
        description: category[0].description,
        file: [category[0].image],
        discount: category[0].discount,
        categoryCode: category[0].categoryCode,
        active: category[0].active,
      })
    }
  }, [category])

  const inputField = [
    { label: 'Category Code', value: categoryForm.categoryCode, name: 'categoryCode', noValidate : true },
    { label: 'Category Name', value: categoryForm.categoryName, name: 'categoryName' },
    { label: 'Description', value: categoryForm.description, name: 'description' },
    { label: 'Image', type: 'IMAGE', name: 'file' },
    { label: 'Status', type: 'ACTIVE', name: 'active', value: categoryForm.active },
  ]
  return <CustomAddPage heading="Category" redirect="CATEGORIES" currentData={category} state={categoryForm} setState={setCategoryForm} handleClick={handleCategory} inputFields={inputField} />
}

export default Category
